import React, { Fragment } from "react"
import MaterialTable from "material-table"
import {
  Button,
  Checkbox,
  FormControlLabel,
  Typography,
  Hidden,
} from "@material-ui/core"
import { findIndex } from "lodash"
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked"
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord"
import MergeRoleDialog from "../mergeRoleDialog"
import { compose } from "recompose"
import { connect } from "react-redux"
import { isEmpty } from "lodash"

class ChildTable extends React.Component {
  constructor() {
    super()
    this.state = {
      mergeSelection: [],
      apiData: {},
      dialogOpen: false,
      mergedRoles: null,
      working: false,
    }
  }

  markSelectedRole = role => {
    const { mergeSelection } = this.state
    let newMergeSelectedRoles = mergeSelection
    let index = findIndex(newMergeSelectedRoles, function(o) {
      return o.id === role.id
    })
    if (index === -1) {
      newMergeSelectedRoles.push(role)
    } else {
      newMergeSelectedRoles.splice(index, 1)
    }
    this.setState({
      mergeSelection: newMergeSelectedRoles,
    })
  }

  mergeSelectedRoles = async () => {
    await this.setState({
      dialogOpen: true,
    })
  }

  updateChild = async () => {
    await this.setState({ working: true })
    await this.props.loadData()
    this.setState({
      dialogOpen: false,
      mergeSelection: [],
      working: false,
    })
  }

  render() {
    const { mergeSelection, dialogOpen, working } = this.state
    const { classes, filteredRoles } = this.props

    return (
      <Fragment>
        <div
          style={{
            margin: "20px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div className={classes.resultsWrapper}>
            {!isEmpty(filteredRoles) && (
              <Typography variant="h6" className={classes.resultsNumber}>
                {filteredRoles.length} Child Roles
              </Typography>
            )}
          </div>
          <div className={classes.padding}>
            <Button
              color="primary"
              disabled={mergeSelection && mergeSelection.length <= 1}
              onClick={() => this.mergeSelectedRoles()}
            >
              {" "}
              Merge Selected ({mergeSelection && mergeSelection.length})
            </Button>
          </div>
        </div>

        {/* WEB VIEW */}
        <Hidden smDown>
          <MaterialTable
            title="Child Roles"
            data={filteredRoles.map(x => {
              if (!x.tableData) {
                x.tableData = {}
              }
              return x
            })}
            columns={[
              { title: "Name", field: "name" },
              { title: "Parents", field: "parents" },
              { title: "Child Count", field: "child_roles" },
              { title: "Shoot Uses", field: "shoot_uses" },
              { title: "Crew Uses", field: "crew_uses" },
              {
                title: "Merge",
                field: "id",
                render: rowData => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        icon={
                          mergeSelection.find(
                            role => role.id === rowData.id
                          ) ? (
                            <FiberManualRecordIcon color="Primary" />
                          ) : (
                            <RadioButtonUncheckedIcon color="Primary" />
                          )
                        }
                        checkedIcon={
                          mergeSelection.find(
                            role => role.id === rowData.id
                          ) ? (
                            <FiberManualRecordIcon color="Primary" />
                          ) : (
                            <RadioButtonUncheckedIcon color="Primary" />
                          )
                        }
                        onClick={() => this.markSelectedRole(rowData)}
                        checked={mergeSelection.find(
                          role => (role.id === rowData.id ? true : false)
                        )}
                      />
                    }
                  />
                ),
              },
            ]}
            parentChildData={(row, rows) =>
              rows.find(a => a.id === row.parentId)
            }
            options={{
              pageSizeOptions: [25, 50, 100],
              pageSize: 25,
              search: false,
              showTitle: false,
              toolbar: false,
            }}
            isLoading={isEmpty(filteredRoles) ? true : false}
          />
        </Hidden>

        {/* MOBILE VIEW */}
        <Hidden mdUp>
          <MaterialTable
            title="Child Roles"
            data={filteredRoles.map(x => {
              if (!x.tableData) {
                x.tableData = {}
              }
              return x
            })}
            columns={[
              { title: "Name", field: "name" },
              {
                title: "Merge",
                field: "id",
                render: rowData => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        icon={
                          mergeSelection.find(
                            role => role.id === rowData.id
                          ) ? (
                            <FiberManualRecordIcon color="Primary" />
                          ) : (
                            <RadioButtonUncheckedIcon color="Primary" />
                          )
                        }
                        checkedIcon={
                          mergeSelection.find(
                            role => role.id === rowData.id
                          ) ? (
                            <FiberManualRecordIcon color="Primary" />
                          ) : (
                            <RadioButtonUncheckedIcon color="Primary" />
                          )
                        }
                        onClick={() => this.markSelectedRole(rowData)}
                        checked={mergeSelection.find(
                          role => (role.id === rowData.id ? true : false)
                        )}
                      />
                    }
                  />
                ),
              },
            ]}
            parentChildData={(row, rows) =>
              rows.find(a => a.id === row.parentId)
            }
            options={{
              pageSizeOptions: [25, 50, 100],
              pageSize: 25,
              search: false,
              showTitle: false,
              toolbar: false,
            }}
            isLoading={isEmpty(filteredRoles) ? true : false}
          />
        </Hidden>

        <MergeRoleDialog
          open={dialogOpen}
          mergeSelection={mergeSelection}
          onSave={() => this.updateChild()}
          onClose={() => this.setState({ dialogOpen: false })}
          working={working}
          setWorking={bool => this.setState({ working: bool })}
        />
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {}
}

export default compose(
  connect(mapStateToProps)
  // withStyles(styles, { withTheme: true })
)(ChildTable)
